import {BaseComparator, Result, ResultState} from './BaseComparator';

type TeamId = string

class TeamComparator implements BaseComparator<TeamId> {
    constructor(private teams: any) {

    }

    compare(guess: TeamId, actual: TeamId): Result {
        if (guess === actual) {
            return {state: ResultState.MATCH};
        } else {
            if (this.teams[guess]["division"] === this.teams[actual]["division"]) {
                return {state: ResultState.CLOSE};
            } else {
                return {state: ResultState.FAR};
            }
        }
    }
}

export {TeamComparator};
export type {TeamId};
